import Header from '../../global/Header';
import StudentProfile from '../../components/ProfilePage/studentProfile'

export default function Profile() {
    return (

        <>
            <Header/>
            <StudentProfile/>
        </>
    )
}

